import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../components/microComponents/BackButton";
import QuestionApi from "../api/services/QuestionApi";
import useQuestionStore from "../stores/useQuestionStore";
import Urls from "../api/Urls";
import scrollToTop from "../components/ScrollTop/ScrollTop";
import Skeleton from "react-loading-skeleton";
import moment from "moment";

const QuestionsList: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { questionsList, setQuestionsList } = useQuestionStore(
    (state) => state
  );

  useEffect(() => {
    scrollToTop();
    fetchApiData();
  }, []);

  const fetchApiData = () => {
    setIsLoading(true);

    QuestionApi.getQuestionSetList({
      onSuccess: (response) => {
        setIsLoading(false);
        setQuestionsList(response.data);
      },
      onError: () => setIsLoading(false),
    });
  };

  const skeleton = (
    <div className="questionsList_main">
      <div className="questionsList">
        {Array.from({ length: 10 }).map((_, index) => (
          <div className="item_col" key={index}>
            <div className="questionsList_item">
              <Skeleton height={50} width={50} className="img" />

              <div className="info">
                <span className="item_name">
                  <Skeleton width={`80%`} />
                  <Skeleton width={`80%`} />
                </span>
                <div className="image">
                  <Skeleton width={100} height={12} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="Container pb-4" style={{ minHeight: "50vh" }}>
      <div className="home_container">
        <BackButton title={"Chapters"} isSticky={true} />

        {isLoading ? (
          skeleton
        ) : (
          <div className="questionsList_main">
            <div className="questionsList">
              {questionsList.map((item) => (
                <div className="item_col" key={item.id}>
                  <div
                    onClick={() => navigate(`${item.id}`)}
                    className="questionsList_item"
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      className="img"
                      src={Urls.storagePath + item.batch?.media}
                      alt="back arrow"
                    />
                    <div className="info">
                      <span className="item_name">{item?.title}</span>
                      <span className="item_name">{item?.description}</span>
                      <div className="image">
                        <span>
                          {moment.utc(item?.publishable_date).fromNow()}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuestionsList;
